export default __webpack_public_path__ + "static/perpetua-io-ogimage-CN-7e4559e1a5b663a432831eaf5b503395.png";